import { memo } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import { Button, Box, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import { initLocalization } from "../../../utils/helpers";
import { mediaListingFiltersStrings } from "./locale";
import { NumericInput } from "../../common/numericInput/NumericInput";
import {
  EXCLUDED_NUMERIC_FIELD_CHARS,
  SEARCH_FIELD_MIN_CHARS,
} from "../../../constants";

export const MediaListingFilters = memo(function MediaListingFilters({
  filters,
  setFilters,
  resetTable,
  getMediaData,
}) {
  initLocalization(mediaListingFiltersStrings);

  const handleFieldChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const handleFieldKeydown = (e) => {
    const idFields = ["mediaId"];

    if (
      idFields.includes(e.target.name) &&
      EXCLUDED_NUMERIC_FIELD_CHARS.includes(e.key)
    ) {
      e.preventDefault();
    }

    if (e.key === "Enter") {
      e.stopPropagation();
      handleSearch();
    }
  };

  const handleSearch = () => {
    if (disableSearch()) {
      return;
    }
    resetTable();
    getMediaData({ ...filters });
  };

  const disableSearch = () => {
    const labelFields = ["mediaLabel"];
    const insufficientChars = labelFields.some(
      (field) =>
        filters[field] !== "" &&
        filters[field].trim().length < SEARCH_FIELD_MIN_CHARS,
    );
    const allFieldsEmpty = ["mediaId", "mediaLabel"].every(
      (field) => filters[field].trim() === "",
    );

    return allFieldsEmpty || insufficientChars;
  };

  return (
    <Grid container>
      <Grid xsOffset="auto" paddingBottom={2}>
        <Button
          startIcon={<Search />}
          variant="contained"
          color="secondary"
          onClick={handleSearch}
          disabled={disableSearch()}
        >
          {mediaListingFiltersStrings.search}
        </Button>
      </Grid>

      <Grid
        xs={12}
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        gap={2}
        paddingY={3}
      >
        <Box
          flexGrow="1"
          sx={{
            "& .MuiTextField-root": { width: "100%" },
          }}
        >
          <NumericInput
            id="outlined-disabled"
            label={mediaListingFiltersStrings.inputs.media.id}
            size="small"
            name="mediaId"
            value={filters.mediaId}
            setValue={(val) =>
              handleFieldChange({ target: { name: "mediaId", value: val } })
            }
            onKeyDown={handleFieldKeydown}
          />
        </Box>
      </Grid>

      <Grid
        xs={12}
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        gap={2}
        paddingBottom={3}
      >
        <Box
          flexGrow="1"
          sx={{
            "& .MuiTextField-root": { width: "100%" },
          }}
        >
          <TextField
            id="outlined-disabled"
            label={mediaListingFiltersStrings.inputs.media.label}
            size="small"
            name="mediaLabel"
            value={filters.mediaLabel}
            onKeyDown={handleFieldKeydown}
            onChange={handleFieldChange}
          />
        </Box>
      </Grid>
    </Grid>
  );
});

MediaListingFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  resetTable: PropTypes.func.isRequired,
  getMediaData: PropTypes.func.isRequired,
};
